import Vue from 'vue'
import axios from 'axios'

import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

axios.defaults.baseURL = ((process.env.NODE_ENV === 'production')
 ? '/api'
 : 'http://localhost/api')


// tslint:disable-next-line
Vue.use(require('vue-tippy').default as any)

import variable from '@/components/variable.vue'
Vue.component('variable', variable)

Vue.config.productionTip = false

store.dispatch('loadData').then(() => {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app')
})
